import { render } from "./draft-orders-index.vue?vue&type=template&id=85a2b024&ts=true"
import script from "./draft-orders-index.vue?vue&type=script&lang=ts"
export * from "./draft-orders-index.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__